import styled from 'styled-components';

export const FunctionParameterStyleOverrideSpan = styled.span`
  .ant-form-item {
    margin-bottom: 0.5rem;
  }
`;
